import { render } from "./User.vue?vue&type=template&id=17f07e72"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"

import "./User.vue?vue&type=style&index=0&id=17f07e72&lang=css"

import exportComponent from "/var/jenkins_home/workspace/aws.dot-account-site.US/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__